<template>
  <div v-scroll-reveal="{ delay: 30, origin: `${slice.primary.cta_align == 'Left' ? 'left' : 'right'}` }" v-bind:class="{'callout load-hidden': true, 'align-left': (slice.primary.cta_align == `Left`), 'align-right': (slice.primary.cta_align == `Right`), 'full-width': (slice.primary.cta_align == `Full`)}">
    <div class="callout-content container">
        <div v-scroll-reveal="{ delay: 30, origin: `${slice.primary.cta_align == 'Left' ? 'left' : 'right'}` }" class="text-container load-hidden">
          <div class="wrapper">
            <h1 :key="0" class="title title-white">{{ $prismic.richTextAsPlain(slice.primary.cta_headline) }}</h1>
            <br/>
            <prismic-rich-text :field="slice.primary.cta_content"/>
            <br/>
            <div :key="1" v-if="slice.primary.cta_button_text">
              <prismic-link :field="slice.primary.cta_button_link" class="button button-white is-uppercase">{{ $prismic.richTextAsPlain(slice.primary.cta_button_text) }}</prismic-link>
            </div>
          </div>
        </div>
        <svg v-if="slice.primary.cta_align ==='Left'" class="is-hidden-mobile" version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	         viewBox="0 0 88 116" style="enable-background:new 0 0 88 116;" xml:space="preserve">
            <circle data-async data-duration="10" data-delay="0" class="red st0" cx="4.4" cy="111" r="3.1"/>
            <line data-async data-duration="10" data-delay="5" class="red st0" x1="4.4" y1="107.8" x2="4.4" y2="49.3"/>
            <circle data-async data-duration="10" data-delay="5" class="red st0" cx="4.4" cy="46.2" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="red st0" points="4.4,43.1 4.4,25.5 68.7,25.5 68.7,34 78.2,34 "/>
            <circle data-async data-duration="10" data-delay="5" class="red st0" cx="81.3" cy="34" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="red st0" points="81.3,30.9 81.3,22.8 75.3,16.8 4.4,16.8 4.4,7.4 "/>
            <circle data-async data-duration="10" data-delay="5" class="red st0" cx="4.4" cy="4.3" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="st0" cx="32.9" cy="4.3" r="3.1"/>
            
            <circle data-async data-duration="10" data-delay="0" class="green st0" cx="18.6" cy="46.2" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="green st0" points="18.6,43.1 18.6,34 54.7,34 54.7,48.2 78.2,48.2 "/>
            <circle data-async data-duration="10" data-delay="5" class="green st0" cx="81.3" cy="48.2" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="st0" cx="32.9" cy="46.2" r="3.1"/>
            
            <circle data-async data-duration="10" data-delay="0" class="darkcyan st0" cx="26.9" cy="61.2" r="3.1"/>
            <line data-async data-duration="10" data-delay="0" class="darkcyan st0" x1="26.9" y1="64.3" x2="26.9" y2="71"/>
            <rect data-async data-duration="10" data-delay="0" class="darkcyan st0" x="21.2" y="71"  width="11.4" height="30.2"/>
            <line data-async data-duration="10" data-delay="0" class="darkcyan st0" x1="26.9" y1="101.2" x2="26.9" y2="107.9"/>   
            <circle data-async data-duration="10" data-delay="0" class="darkcyan st0" cx="26.9" cy="111.1" r="3.1"/>

            <circle data-async data-duration="10" data-delay="0" class="plum st0" cx="45" cy="61.2" r="3.1"/>
            <line data-async data-duration="10" data-delay="0" class="plum st0" x1="45" y1="64.3" x2="45" y2="71"/>
            <rect data-async data-duration="10" data-delay="0" class="plum st0" x="39.3" y="71" width="11.4" height="30.2"/>
            <line data-async data-duration="10" data-delay="0" class="plum st0" x1="45" y1="101.2" x2="45" y2="107.9"/>
            <circle data-async data-duration="10" data-delay="0" class="plum st0" cx="45" cy="111.1" r="3.1"/>
            <circle data-async data-duration="10" data-delay="0" class="st0" cx="18.6" cy="4.3" r="3.1"/>

            <circle data-async data-duration="10" data-delay="0" class="orange st0" cx="63" cy="61.2" r="3.1"/>
            <line data-async data-duration="10" data-delay="0" class="orange st0" x1="63" y1="64.3" x2="63" y2="71"/>
            <rect data-async data-duration="10" data-delay="0" class="orange st0" x="57.3" y="71" width="11.4" height="30.2"/>
            <line data-async data-duration="10" data-delay="0" class="orange st0" x1="63" y1="101.2" x2="63" y2="107.9"/>
            <circle data-async data-duration="10" data-delay="0" class="orange st0" cx="63" cy="111.1" r="3.1"/>

            <circle data-async data-duration="10" data-delay="0" class="crimson st0" cx="81" cy="61.2" r="3.1"/>
            <line data-async data-duration="10" data-delay="0" class="crimson st0" x1="81" y1="64.3" x2="81" y2="71"/>
            <rect data-async data-duration="10" data-delay="0" class="crimson st0" x="75.3" y="71" width="11.4" height="30.2"/>
            <line data-async data-duration="10" data-delay="0" class="crimson st0" x1="81" y1="101.2" x2="81" y2="107.9"/>
            <circle data-async data-duration="10" data-delay="0" class="crimson st0" cx="81" cy="111.1" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="st0" cx="81.3" cy="4.3" r="3.1"/>
          </svg>
          <svg v-else-if="slice.primary.cta_align ==='Right'" class="is-hidden-mobile" version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 110.8 103.5" style="enable-background:new 0 0 110.8 103.5;" xml:space="preserve">
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="87.2" cy="37.5" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="76.9" cy="18.2" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="48.6" cy="43.8" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="plum st2" points="87.2,34.4 87.2,1.7 38.3,1.7 29.5,10.5 29.5,25.4 46.1,42 "/>
            <line data-async data-duration="10" data-delay="5" class="plum st2" x1="80" y1="18.2" x2="87.2" y2="18.2"/>
            
            <circle data-async data-duration="10" data-delay="0" class="green st2" cx="5" cy="47" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="green st2" points="8.2,47 14.1,47 41.5,74.3 87.2,74.3 87.2,95.5 "/>
            <circle data-async data-duration="10" data-delay="5" class="green st2" cx="87.2" cy="98.7" r="3.1"/>

            <circle data-async data-duration="10" data-delay="0" class="yellow st2" cx="5" cy="32.2" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="yellow st2" points="8.2,32.2 15,32.2 42.7,59.9 106,59.9 106,95.5 "/>
            <circle data-async data-duration="10" data-delay="5" class="yellow st2" cx="106" cy="98.7" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="106" cy="37.5" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="darkcyan st2" points="106,40.7 106,51.9 68.3,51.9 68.3,40.7 "/>
            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="68.3" cy="37.6" r="3.1"/>
            <line data-async data-duration="10" data-delay="5" class="darkcyan st2" x1="66.1" y1="35.3" x2="51.5" y2="20.8"/>
            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="49.5" cy="18.5" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="red st2" cx="68.3" cy="98.7" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="red st2" cx="5" cy="61.7" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="red st2" points="8.2,61.7 14.1,61.7 39,86.6 68.3,86.6 68.3,95.5 "/>
          </svg>
          <svg class="full-width-svg is-hidden-mobile" v-else version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 110.8 103.5" style="enable-background:new 0 0 110.8 103.5;" xml:space="preserve">
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="87.2" cy="37.5" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="76.9" cy="18.2" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="plum st2" cx="48.6" cy="43.8" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="plum st2" points="87.2,34.4 87.2,1.7 38.3,1.7 29.5,10.5 29.5,25.4 46.1,42 "/>
            <line data-async data-duration="10" data-delay="5" class="plum st2" x1="80" y1="18.2" x2="87.2" y2="18.2"/>
            
            <circle data-async data-duration="10" data-delay="0" class="green st2" cx="5" cy="47" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="green st2" points="8.2,47 14.1,47 41.5,74.3 87.2,74.3 87.2,95.5 "/>
            <circle data-async data-duration="10" data-delay="5" class="green st2" cx="87.2" cy="98.7" r="3.1"/>

            <circle data-async data-duration="10" data-delay="0" class="yellow st2" cx="5" cy="32.2" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="yellow st2" points="8.2,32.2 15,32.2 42.7,59.9 106,59.9 106,95.5 "/>
            <circle data-async data-duration="10" data-delay="5" class="yellow st2" cx="106" cy="98.7" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="106" cy="37.5" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="darkcyan st2" points="106,40.7 106,51.9 68.3,51.9 68.3,40.7 "/>
            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="68.3" cy="37.6" r="3.1"/>
            <line data-async data-duration="10" data-delay="5" class="darkcyan st2" x1="66.1" y1="35.3" x2="51.5" y2="20.8"/>
            <circle data-async data-duration="10" data-delay="5" class="darkcyan st2" cx="49.5" cy="18.5" r="3.1"/>

            <circle data-async data-duration="10" data-delay="5" class="red st2" cx="68.3" cy="98.7" r="3.1"/>
            <circle data-async data-duration="10" data-delay="5" class="red st2" cx="5" cy="61.7" r="3.1"/>
            <polyline data-async data-duration="10" data-delay="5" class="red st2" points="8.2,61.7 14.1,61.7 39,86.6 68.3,86.6 68.3,95.5 "/>
          </svg>
    </div>
    </div>
</template>

<script>
export default {
  name: 'CallToAction',
  props: ['slice']
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../../assets/sass/colors.scss";

.st0 {
  fill: none;
  stroke:#2A335F;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.st2 {
  fill: none;
  stroke:#2A335F;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.callout {
  color: $white;
  position: relative;
  margin: 150px 0;
  // background: $navy;

  .text-container {
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 100%;
  }

  &:after {
    content: '';
    position: absolute;
    width: calc(50% + 660px);
    max-width: 75vw;
    height: 100%;
    top: 0;
    background: $navy;
    @media screen and (max-width: $desktop) {
      max-width: 85vw;
    }
    @media screen and (max-width: $tablet) {
      max-width: 100vw;
    }
  }

  &.align-left {
    &:after {
      left: 0;
      border-radius: 0 200px 200px 0;
    }

    svg {
      height: 300px;
      position: absolute;
      right: 25vw;
      top: 0;
      bottom: 0;
      margin: auto;
      @media screen and (max-width: $desktop) {
        height: 200px;
        right: 15vw;
      }
      @media screen and (max-width: $tablet) {
        display: none;
      }
    }
  }

  &.align-right {
    &:after {
      right: 0;
      border-radius: 200px 0 0 200px;
    }

    .text-container {
      flex-direction: row-reverse;
    }

    svg {
      height: 300px;
      position: absolute;
      left: 25vw;
      top: 0;
      bottom: 0;
      margin: auto;
      @media screen and (max-width: $desktop) {
        height: 200px;
        left: 15vw;
      }
      @media screen and (max-width: $tablet) {
        display: none;
      }
    }
  }

  &.full-width {
    margin-bottom: 0;
    &:after {
      width: 100%;
      max-width: none;
    }

    svg {
      height: 300px;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
}

.callout-content {
  padding-top: 150px;
  padding-bottom: 150px;
  // position: relative;
  z-index: 2;
}

.callout-background {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: calc(50% + 660px);
  max-width: 80vw;
  height: 100%;
  background: $navy;
  border-radius: 0 0 200px 0;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  z-index: 1;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
